<template>
  <div v-if="visible" class="pop_mask">
    <div class="pop_content">
      <div class="pop_info">
        <div class="login_title">请选择登录账号</div>
        <div class="login_link">
          <a href="javascript:;" class="login_qq" @click="login(2)"></a>
          <a href="javascript:;" class="login_wx" @click="login(1)"></a>
        </div>
      </div>
      <a href="javascript:;" @click="close" class="pop_close db">关闭</a>
    </div>
    <div class="loading_box" v-if="loadingState">
      <img src="/img/pc/loading.gif" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { defineProps, defineEmits } from "vue";
import { toast } from "vue3-toastify"; // 引入toast组件
import { openQqLogin, openWxPcLogin, setToken } from "@/utils/qwLogin";
import { isNotWidthPhone } from "@/utils/index";
import { clickLogin } from "@/utils/reporting";

const props = defineProps({
  // 定义props
  visible: Boolean, // 是否显示弹窗
});
const emit = defineEmits(["close", "handle"]); // close事件
function close() {
  emit("close");
}

const loadingState = ref(false); // 定义一个ref来保存loading状态

function showToast(msg) {
  toast.info(msg);
}

const login = (type) => {
  clickLogin(type);
  if (type == 2) {
    openQqLogin();
  } else {
    if (!isNotWidthPhone()) {
      openWxPcLogin();
    } else {
      emit("handle");
    }
  }
  window.addEventListener("message", (event) => {
    if (event.data && event.data.type == "loginManager_QW_PC") {
      console.log(event.data);
      setToken(event.data.token);
      window.location.reload();
      close();
    }
  });
};
</script>

<style lang="scss" scoped>
.pop_mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.pc_wrap {
  .loading_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: calc(80 / 2560 * 100vw);
      height: calc(80 / 2560 * 100vw);
    }
  }
  .pop_content {
    background: url(/img/pc/pop.png) no-repeat;
    background-size: 100% 100%;
    width: calc(887 / 2560 * 100vw);
    height: calc(522 / 2560 * 100vw);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: showPop 0.5s ease both;
    .login_title {
      text-align: center;
      font-family: "font2";
      font-size: calc(38 / 2560 * 100vw);
      color: #443a2b;
      line-height: calc(46 / 2560 * 100vw);
      margin-bottom: calc(50 / 2560 * 100vw);
    }
    .login_link {
      display: flex;
      justify-content: center;
      text-align: center;
      a {
        width: calc(220 / 2560 * 100vw);
        height: calc(259 / 2560 * 100vw);
        margin: 0 calc(45 / 2560 * 100vw);
        transition: all 0.3s;
      }
      a:hover {
        filter: brightness(1.1);
      }
      .login_qq {
        background: url(/img/pc/qq.png) no-repeat;
        background-size: 100% 100%;
      }
      .login_wx {
        background: url(/img/pc/wx.png) no-repeat;
        background-size: 100% 100%;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .pop_close {
    position: absolute;
    right: calc(-25 / 2560 * 100vw);
    top: 0;
    background: url(/img/pc/close.png) no-repeat;
    background-size: 100% 100%;
    width: calc(52 / 2560 * 100vw);
    height: calc(49 / 2560 * 100vw);
    transition: all 0.3s;
  }
  .pop_close:hover {
    transform: scale(1.1);
  }
  .pop_close:active {
    transform: scale(1);
  }

  @keyframes showPop {
    0% {
      transform: translateY(calc(-10 / 2560 * 100vw));
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
.mobile_wrap {
  .loading_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: calc(80 / 750 * 100vw);
      height: calc(80 / 750 * 100vw);
    }
  }
  .pop_content {
    background: url(/img/m/pop.png) no-repeat;
    background-size: 100% 100%;
    width: calc(678 / 750 * 100vw);
    height: calc(401 / 750 * 100vw);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: showPop 0.5s ease both;
    .login_title {
      text-align: center;
      font-family: "font2";
      font-size: calc(32 / 750 * 100vw);
      color: #443a2b;
      line-height: calc(36 / 750 * 100vw);
      margin-bottom: calc(40 / 750 * 100vw);
    }
    .login_link {
      display: flex;
      justify-content: center;
      text-align: center;
      a {
        width: calc(175 / 750 * 100vw);
        height: calc(212 / 750 * 100vw);
        margin: 0 calc(20 / 750 * 100vw);
        transition: all 0.3s;
      }
      a:hover {
        filter: brightness(1.1);
      }
      .login_qq {
        background: url(/img/m/qq.png) no-repeat;
        background-size: 100% 100%;
      }
      .login_wx {
        background: url(/img/m/wx.png) no-repeat;
        background-size: 100% 100%;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .pop_close {
    position: absolute;
    right: calc(-20 / 750 * 100vw);
    top: 0;
    background: url(/img/pc/close.png) no-repeat;
    background-size: 100% 100%;
    width: calc(42 / 750 * 100vw);
    height: calc(41 / 750 * 100vw);
    transition: all 0.3s;
  }
  .pop_close:hover {
    transform: scale(1.1);
  }
  .pop_close:active {
    transform: scale(1);
  }

  @keyframes showPop {
    0% {
      transform: translateY(calc(-10 / 750 * 100vw));
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
